export default "__VITE_ASSET__miQava_u__"